import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  header: {
    id: 'report.summary.header',
    description: 'Summary header',
    defaultMessage: 'Yhteenveto',
  },
  marketingName: {
    id: 'report.summary.marketingName',
    description: 'Marketing name',
    defaultMessage: 'Yrityksen antama markkinointinimi',
  },
  industry: {
    id: 'report.summary.industry',
    description: 'Industry',
    defaultMessage: 'Toimiala',
  },
  companyIsBankrupt: {
    id: 'report.summary.companyIsBankrupt',
    description: 'Company is bankrupt',
    defaultMessage: 'Yritys on konkurssissa!',
  },
  readMore: {
    id: 'report.summary.readMore',
    description: 'Read more',
    defaultMessage: 'Lue lisää',
  },
  readLess: {
    id: 'report.summary.readLess',
    description: 'Read less',
    defaultMessage: 'Pienennä',
  },
  recommendLuotettavaKumppani: {
    id: 'report.summary.recommendLuotettavaKumppani',
    description: 'Recommend for Luotettava Kumppani service',
    defaultMessage: 'Suosittele Luotettava Kumppani -palveluun',
  },
  thankForRecommending: {
    id: 'report.summary.thankForRecommending',
    description: 'Thank for recommending',
    defaultMessage: 'Kiitos suosittelusta!',
  },
  marketingNamePlaceholder: {
    id: 'report.summary.marketingNamePlaceholder',
    description: 'Marketing name placeholder',
    defaultMessage: 'markkinointinimi',
  },
  marketingNameLabel: {
    id: 'report.summary.marketingNameLabel',
    description: 'Marketing name label',
    defaultMessage: 'Markkinointinimi',
  },
  primaryNameLabel: {
    id: 'report.summary.primaryNameLabel',
    description: 'Primary name label',
    defaultMessage: 'Viralliset nimet',
  },
  alternativeNamesLabel: {
    id: 'report.summary.alternativeNamesLabel',
    description: 'Alternative names label',
    defaultMessage: 'Aputoiminimet',
  },
  marketingNameInfo: {
    id: 'report.summary.marketingNameInfo',
    description: 'Marketing name info',
    defaultMessage:
      'Markkinointinimi on yrityksen vapaasti valittava epävirallinen nimi, joka näytetään ensisijaisena nimenä Zeckit-sivustolla.',
  },
  primaryNameInfo: {
    id: 'report.summary.primaryNameInfo',
    description: 'Primary name info',
    defaultMessage:
      'Yrityksen virallista yritysrekisterissä olevaa ensisijaista nimeä tai aputoiminimiä ei voi muokata vapaasti.',
  },
  alternativeNamesInfo: {
    id: 'report.summary.alternativeNamesInfo',
    description: 'Alternative names info',
    defaultMessage:
      'Yrityksellä voi olla useita vapaavalintaisia aputoiminimiä, jotka voivat olla esimerkiksi entisiä nimiä tai vaihtoehtoisia kirjoitusasuja.',
  },
  bankrupt: {
    id: 'report.summary.bankrupt',
    description: 'Bankrupt explanation',
    defaultMessage: `<h2>Varoitus</h2>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen toiminta on lakannut, koska se on konkurssissa ja kyvytön hoitamaan vastuitaan. Ostaessasi konkurssiyritykseltä menetät todennäköisesti maksamasi rahat ja ostamasi palvelut jäävät saamatta.</p>`,
  },
  bankrupt_details: {
    id: 'report.summary.bankrupt.details',
    description: 'Bankrupt detailed explanation',
    defaultMessage: `<p>Konkurssilla tarkoitetaan sitä, ettei velallinen kykene suorittamaan velkojaan ja vastuitaan. Konkurssia voi hakea velkojat tai yritys itse. Yritys asetetaan konkurssiin aina tuomioistuimen toimesta ja siitä tehdään merkintä konkurssirekisteriin, kaupparekisteriin ja luottotietorekistereihin, jonka lisäksi siitä tiedotetaan julkisesti.</p>
                     <p>Konkurssi voidaan myös peruuttaa velallisen ja velkojan yhteisestä hakemuksesta.</p>`,
  },
  ceased: {
    id: 'report.summary.ceased',
    description: 'Ceased explanation',
    defaultMessage: `<h2>Varoitus</h2>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen toiminta on lakannut.</p>`,
  },
  ceased_details: {
    id: 'report.summary.ceased.details',
    description: 'Ceased detailed explanation',
    defaultMessage: '',
  },
  business_ban: {
    id: 'report.summary.businessBan',
    description: 'Business ban explanation',
    defaultMessage: `<h2>Varoitus</h2>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen vastuuhenkilö on tuomittu talousrikoksesta ja on liiketoimintakiellossa. Ostaessasi liiketoimintakiellossa olevalta yritykseltä otat riskin.</p>`,
  },
  business_ban_details: {
    id: 'report.summary.businessBan.details',
    description: 'Business ban detailed explanation',
    defaultMessage: `<p>Liiketoimintakielto määrätään aina tuomioistuimen toimesta ja siitä tehdään merkintä liiketoimintakieltorekisteriin, kaupparekisteriin ja luottotietorekistereihin, jonka lisäksi siitä tiedotetaan julkisesti. Liiketoimintakielto on voimassa vain Suomessa ja liiketoimintakieltoon määrätty henkilö voi harjoittaa toimintaa muualla EU:ssa.</p>
                     <p>Liiketoimintakielto on määräaikainen ja se voidaan rajata koskemaan vain tietyn tyyppistä yritystoimintaa.</p>`,
  },
  ok_luotettava_kumppani: {
    id: 'report.summary.luotettavaKumppani',
    description: 'Luotettava kumppani expalanation',
    defaultMessage: `<h2>Luotettava Kumppani</h2>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen toiminta on läpinäkyvää, koska se on antanut luvan tarkastaa laajasti omat tietonsa, esimerkiksi vero- ja työeläketiedot, Luotettava Kumppani  -ohjelmassa. Tietojen perusteella yritys on hoitanut velvoitteensa hyvin.</p>`,
  },
  ok_luotettava_kumppani_details: {
    id: 'report.summary.luotettavaKumppani.details',
    description: 'Luotettava kumppani detailed expalanation',
    defaultMessage: `<p>Tiedot voidaan tarkastaa, koska yritys on mukana Luotettava Kumppani -ohjelmassa.</p>
                     <p>Suuremmissa hankinnoissa kannattaa kuitenkin aina pyytää myös referenssit ja katsoa yrityksen saamat arvioinnit.</p>`,
  },
  ok_luotettava_kumppani_registry: {
    id: 'report.summary.luotettavaKumppaniRegistry',
    description: 'Luotettava kumppani registry explanation',
    defaultMessage: `<h2>Luotettava Kumppani</h2>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen toiminta on läpinäkyvää, koska se on antanut luvan tarkastaa laajasti omat tietonsa, esimerkiksi vero- ja työeläketiedot, Luotettava Kumppani –ohjelmassa. Tietojen perusteella yritys on hoitanut velvoitteensa hyvin.</p>`,
  },
  ok_luotettava_kumppani_registry_details: {
    id: 'report.summary.luotettavaKumppaniRegistry.details',
    description: 'Luotettava kumppani registry detailed explanation',
    defaultMessage: `<p>Yrityksen ei tarvitse kuulua kaikkiin rekistereihin, jos toiminta on pientä, eikä sillä ole esimerkiksi useita vakituisia työntekijöitä.</p>
                     <p></Tiedot voidaan tarkastaa, koska yritys on mukana Luotettava Kumppani -ohjelmassa. Suuremmissa hankinnoissa kannattaa kuitenkin aina pyytää myös referenssit ja katsoa yrityksen saamat arvoinnit.p>`,
  },
  warning_responsibilities: {
    id: 'report.summary.warningResponsibilities',
    description: 'Warning responsibilities explanation',
    defaultMessage: `<h2>Käytä harkintaa</h2>
                     <p>Zeckit-palvelun tietolähteiden mukaan voit tehdä huoletta arvoltaan pieniä ostoksia. Suuremmat hankinnat kannattaa maksaa pienissä erissä ja välttää hankintoja, joissa takuun merkitys on suuri.</p>`,
  },
  warning_responsibilities_details: {
    id: 'report.summary.warningResponsibilities.details',
    description: 'Warning responsibilities detailed explanation',
    defaultMessage: `<p>Yritys ei kuitenkaan ole hoitanut kaikkia vastuitaan ajallaan. Hoidettavia vastuita ovat esimerkiksi yrityksen verot ja työntekijöiden eläkkeet.</p>
                     <p>Merkintä tulee yritykselle, jolla on verovelkaa tai muita yritysvastuuseen kuuluvia hoitamattomia maksuja. Tiedot saadaan tarkastettua ainoastaan Luotettava Kumppani-ohjelmassa mukana olevilta yrityksiltä. Merkintä tulee, jos työeläkemaksut on laiminlyöty tai veroja on maksamatta yli 10 000 euroa.</p>`,
  },
  warning_credit_notice: {
    id: 'report.summary.warningCreditNotice',
    description: 'Warning credit notice explanation',
    defaultMessage: `<h2>Käytä harkintaa</h2>
                     <p>Zeckit-palvelun tietolähteiden mukaan voit tehdä huoletta arvoltaan pieniä ostoksia. Suuremmat hankinnat kannattaa maksaa pienissä erissä ja välttää hankintoja, joissa takuun merkitys on suuri.</p>`,
  },
  warning_credit_notice_details: {
    id: 'report.summary.warningCreditNotice.details',
    description: 'Warning credit notice detailed explanation',
    defaultMessage: `<p>Yritys ei kuitenkaan ole hoitanut kaikkia vastuitaan ajallaan. Hoidettavia vastuita ovat esimerkiksi yrityksen verot ja työntekijöiden eläkkeet. Maksuhäiriömerkintä syntyy riidattomasta saatavasta yksipuolisen tuomion perusteella tai saatava on laissa määritelty suoraan ulosottokelpoiseksi.</p>
                     <p>Merkintä tulee yritykselle, jolla on verovelkaa tai muita yritysvastuuseen kuuluvia hoitamattomia maksuja. Tiedot saadaan tarkastettua ainoastaan Luotettava Kumppani-ohjelmassa mukana olevilta yrityksiltä. Merkintä tulee, jos työeläkemaksut on laiminlyöty tai veroja on maksamatta yli 10 000 euroa.</p>`,
  },
  ok: {
    id: 'report.summary.ok',
    description: 'Ok explanation',
    defaultMessage: `<h2>Perustiedot kunnossa</h2>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen perustiedot ovat kunnossa ja toiminta vaikuttaa normaalilta. Vero- ja työeläkemaksutietoja ei kuitenkaan voida tarkastaa, koska yritys ei ole mukana <a href="https://www.vastuugroup.fi/fi-fi/palvelut/luotettava-kumppani">Luotettava Kumppani –palvelussa</a>.</p>`,
  },
  ok_details: {
    id: 'report.summary.ok.details',
    description: 'Ok detailed explanation',
    defaultMessage: `<p><strong>Tarkasta aina verovelat <a href="https://www.ytj.fi/">YTJ -yrityshausta</a>.</strong> YTJ -yrityshaussa näytetään yli 10.000 euron verovelat.</p>
                     <p>Suuremmissa hankinnoissa kannattaa kuitenkin aina pyytää myös referenssit ja katsoa yrityksen saamat arvioinnit.</p>
                     <p>Selvitys on suppea, koska yrityksen Luotettava Kumppani –raporttia ei ole mahdollista tarkistaa, koska yritys ei kuulu Luotettava Kumppani –palveluun.</p>`
  },
  waiting_info: {
    id: 'report.summary.waitingInfo',
    description: 'Waiting for information explanation',
    defaultMessage: `<h2>Perustiedot kunnossa</h2>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen perustiedot ovat kunnossa ja toiminta vaikuttaa normaalilta.</p>
                     <p>Yritys on liittynyt Luotettava Kumppani -palveluun, mutta osaa raportin tiedoista odotetaan vielä.</p>`,
  },
  waiting_info_details: {
    id: 'report.summary.waitingInfo.details',
    description: 'Waiting for information detailed explanation',
    defaultMessage: '<p><strong>Tarkasta aina verovelat <a href="https://www.ytj.fi/">YTJ -yrityshausta</a>.</strong> YTJ -yrityshaussa näytetään yli 10.000 euron verovelat.</p> <p>Suuremmissa hankinnoissa kannattaa kuitenkin aina pyytää myös referenssit ja katsoa yrityksen saamat arvioinnit.</p>',
  },
  unknown: {
    id: 'report.summary.unknown',
    description: 'Unknown explanation',
    defaultMessage: 'Tuntematon ensimmäisen tason tulkinta: {firstLevel}',
  },
  facebookShareTitle: {
    id: 'report.summary.facebookShareTitle',
    description: 'Title for post shared in Facebook',
    defaultMessage: 'Katsoin juuri Zeckit-selvityksen, katso sinäkin!',
  },
  facebookShareDescription: {
    id: 'report.summary.facebookShareDescription',
    description: 'Description for post shared in Facebook',
    defaultMessage: 'Katsoin juuri Zeckit-selvityksen, katso sinäkin!',
  },
  twitterShareTitle: {
    id: 'report.summary.twitterShareTitle',
    description: 'Title for post shared in Twitter',
    defaultMessage: 'Katsoin juuri Zeckit-selvityksen, katso sinäkin!',
  },
  // EDIT MODE
  taxPrepaymentActive: {
    id: 'report.summary.taxPrepaymentActive',
    description:
      'According to our info a tax prepayment is possible but you can change the info using button below',
    defaultMessage:
      'Tietojemme mukaan yrityksesi tekemästä työstä saa kotitalousvähennyksen. Voit kuitenkin määrittää tiedon itse alla olevasta napista.',
  },
  taxPrepaymentInactive: {
    id: 'report.summary.taxPrepaymentInactive',
    description:
      'According to our info a tax prepayment is not possible but you can change the info using button below',
    defaultMessage:
      'Tietojemme mukaan yrityksesi tekemästä työstä ei saa kotitalousvähennyksen. Voit kuitenkin määrittää tiedon itse alla olevasta napista.',
  },
  taxPrepaymentDisable: {
    id: 'report.summary.taxPrepaymentDisable',
    description: 'Click here to disable tax prepayment',
    defaultMessage:
      'Klikkaa tästä, jos yrityksesi ei tarjoa kotitalousvähennystä',
  },
  taxPrepaymentEnable: {
    id: 'report.summary.taxPrepaymentEnable',
    description: 'Click here to enable tax prepayment',
    defaultMessage:
      'Klikkaa tästä, jos yrityksesi tarjoaa kotitalousvähennyksen',
  },
  expandList: {
    id: 'report.summary.expandList',
    description: 'Click to expand list',
    defaultMessage: 'Näytä kaikki',
  },
  contractList: {
    id: 'report.summary.contractList',
    description: 'Click to contract list',
    defaultMessage: 'Näytä vähemmän',
  },
});
